import { Box, Typography, Tooltip } from '@mui/material'

const StatsSummary = ({ title, value, color, tooltipText }) => (
  <Box className="statsSummaryBox">
    <Typography className="statsSummaryBoxTitle" variant="body1" color='primary'>
      {title}
    </Typography>
    { tooltipText ?
      <Typography className="statsSummaryBoxValue" variant="body2" color={color}>
        <Tooltip
          title={tooltipText}
          PopperProps={{
            sx: {
              '& .MuiTooltip-tooltip': {
                backgroundColor: 'primary.main'
              }
            },
          }}
        >
          <span style={{ color: 'inherit', cursor: 'pointer' }}>{value}</span>
        </Tooltip>
      </Typography> :
      <Typography className="statsSummaryBoxValue" variant="body2" color={color}>
        {value}
      </Typography>
    }
  </Box>
)

export default StatsSummary